export const THEME_COLORS = {
    GREEN: '#21ba45',
    ORANGE: '#fb923c',
    RED: '#d22421'
}
